<template>
    <div
        class="dm-default-cover-image-selector"
        v-if="presentation.cover_image_type == 'default'"
    >
        <label
            v-for="coverImage in default_cover_images"
            :key="'cover-image-' + coverImage.id"
            :class="{
                active: presentation.default_cover_image_id == coverImage.id,
            }"
        >
            <input
                type="radio"
                v-model="presentation.default_cover_image_id"
                :value="coverImage.id"
                @change="savePresentation()"
            />

            <DefaultCoverOption
                :cover_image="coverImage"
                :title="presentation.content.title"
                :author_name="presentation.content.author_name"
            />
        </label>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState, mapWritableState, mapActions } from "pinia";
import DefaultCoverOption from "./DefaultCoverOption.vue";

export default {
    components: { DefaultCoverOption },

    computed: {
        ...mapState(useSubmissionWizardStore, ["default_cover_images"]),
        ...mapWritableState(useSubmissionWizardStore, ["presentation"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, [
            "loadDefaultCoverImages",
            "savePresentation",
        ]),
    },

    mounted() {
        this.loadDefaultCoverImages();
    },
};
</script>
